import React from 'react';
import { Spin } from 'antd';

const AppLoader = () => {
  return (
    <div
      style={{
        display: 'grid',
        placeContent: 'center',
        height: 'calc(100vh - 60px - 48px)',
      }}
    >
      <Spin size={'large'} />
    </div>
  );
};

export default AppLoader;
